import React, { useEffect, useState } from "react";
import {
  Box,
  Text,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import Farmer from "../Farmer";
import Broker from "../Brokers";
import ThirdPartySuppliers from "../ThirdPartySuppliers";
import APMC from "../APMC";
import { useSelector } from "react-redux";

function Supplier() {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const { userData } = useSelector((state) => state.auth);

  const handleTabsChange = (index) => {
    setActiveTabIndex(index);
    localStorage.setItem("activeTabIndex", index);
  };

  useEffect(() => {
    const savedTabIndex = localStorage.getItem("activeTabIndex");
    if (savedTabIndex !== null) {
      setActiveTabIndex(parseInt(savedTabIndex, 10));
    }
  }, []);

  const isGinner = userData?.role?.includes("GINNER");

  return (
    <Box paddingTop={"3rem"}>
      <Box>
        <Text color={"#141D43"} fontSize="28px" fontWeight={"600"}>
          Suppliers
        </Text>
        <Text color={"#3958DC"} fontSize="sm">
          All suppliers that were added by you
        </Text>
      </Box>

      {/* Render Tabs Conditionally */}
      {isGinner ? (
        <Tabs
          p="1rem"
          isLazy
          index={activeTabIndex}
          onChange={handleTabsChange}
        >
          <TabList>
            <Tab>
              <Text color={"#141D43"} fontSize="18px">
                Farmers
              </Text>
            </Tab>
            <Tab>
              <Text color={"#141D43"} fontSize="18px">
                Broker
              </Text>
            </Tab>
            <Tab>
              <Text color={"#141D43"} fontSize="18px">
                APMC
              </Text>
            </Tab>
            <Tab>
              <Text color={"#141D43"} fontSize="18px">
                Third Party Supplier
              </Text>
            </Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <Farmer />
            </TabPanel>
            <TabPanel>
              <Broker />
            </TabPanel>
            <TabPanel>
              <APMC />
            </TabPanel>
            <TabPanel>
              <ThirdPartySuppliers />
            </TabPanel>
          </TabPanels>
        </Tabs>
      ) : (
        <Tabs
          p="1rem"
          isLazy
          index={0} // Force index to 0 since there is only one tab
        >
          <TabList>
            <Tab>
              <Text color={"#141D43"} fontSize="18px">
                Third Party Supplier
              </Text>
            </Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <ThirdPartySuppliers />
            </TabPanel>
          </TabPanels>
        </Tabs>
      )}
    </Box>
  );
}

export default Supplier;
